import { GetFeatureFlags } from '@/connection/feature-flags';
import { store } from '@/store/main';
import { setFeatureFlags } from '@/store/slices/feature-flags';
import blAuth from '@/connection/bl-auth/bl-auth';
import { setAuthTokens } from '@/store/slices/user';
import { loadChannels } from '@/store/slices/channels';
import { loadTemplates } from '@/connection/loaders/templates';

let authReadyResolver: (() => void) | null = null;

export const authReady = new Promise<void>((resolve) => {
  authReadyResolver = resolve;
});

export const mainLoader = async ({ request }: { request: Request }): Promise<Response> => {
  try {
    const loadFeatureFlags = async () => {
      const featureFlags = await GetFeatureFlags();
      store.dispatch(setFeatureFlags(featureFlags));
    };

    const auth = async () => {
      await blAuth.handleRedirected();
      const url = new URL(window.location.href);
      let theme = undefined;

      if (url.pathname.startsWith('/webinarplus')) {
        theme = 'webinarplus';
      }
      if (blAuth.refreshToken) {
        await blAuth.refresh();
        blAuth.initializeActivityTracker({ refreshOnInterval: true });
      } else {
        blAuth.redirectToSignIn({ redirect_uri: window.location.href, theme });
      }
      store.dispatch(
        setAuthTokens({
          idToken: blAuth.idToken as string,
          refreshToken: blAuth.refreshToken as string,
        })
      );
      store.dispatch(loadChannels({ useCache: true }));
      authReadyResolver?.();
    };

    // we don't need to await this one because it'll block the rest of the UI
    // however we DO want this to be loaded as soon as the app loads
    loadTemplates(request).catch(console.error);

    await Promise.all([loadFeatureFlags(), auth()]);
    return new Response(null, { status: 200 });
  } catch (error) {
    console.error(error);
    authReadyResolver?.();
    return new Response(null, { status: 500 });
  }
};
